import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/common/hooks';
import { MobileCard } from '@yme/components/HomePage/components/SpecialOffers/MobileCard';
import { TabletCards } from '@yme/components/HomePage/components/SpecialOffers/TabletCards';
import { IndentWrapper } from '@yme/components/Separator';
import { SectionWrapper } from '@yme/molecules/section-wrapper';
import { getRTL } from '@yme/selectors/common';
import { DesktopCards } from './DesktopCards';
export function SpecialOffers(props) {
    const { isRemoveBottomIndent, cards, header } = props;
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView, isTabletView, isInfiniteDesktopView } = useWindowSize();
    if (props?.cards?.length === 0) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, null,
            React.createElement(SectionWrapper, { headerLeftSide: header, isVerticalIndentDefault: false, isRightToLeft: isRightToLeft, headerMobileMb: "24px" },
                isInfiniteDesktopView && (React.createElement(DesktopCards, { cards: cards, isRightToLeft: isRightToLeft })),
                isTabletView && (React.createElement(TabletCards, { cards: cards, isRightToLeft: isRightToLeft })),
                isMobileView && (React.createElement(MobileCard, { cards: cards, isRightToLeft: isRightToLeft }))))));
}
SpecialOffers.displayName = 'SpecialOffers_AEMComponent';
